'use strict';

var crypto = require('crypto');

var isObject = require('is-obj');

var sortKeys = require('sort-keys');

module.exports = function (object) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$encoding = _ref.encoding,
      encoding = _ref$encoding === void 0 ? 'hex' : _ref$encoding,
      _ref$algorithm = _ref.algorithm,
      algorithm = _ref$algorithm === void 0 ? 'sha512' : _ref$algorithm;

  if (!isObject(object)) {
    throw new TypeError('Expected an object');
  }

  if (encoding === 'buffer') {
    encoding = undefined;
  }

  return crypto.createHash(algorithm).update(JSON.stringify(sortKeys(object, {
    deep: true
  })), 'utf8').digest(encoding);
};